import Vue from 'vue';

import EventHub from './event-hub';

Vue.use(EventHub);
